/**
 * The two small pieces under the availability calendar: what its colours
 * mean, and — while days are being picked — how many, and the button that
 * sets them.
 */

export function AvailabilityLegend(): JSX.Element {
  return (
    <div className="cal-legend" aria-hidden="true">
      <span className="cal-legend__item">
        <span className="cal-swatch cal-swatch--available" /> Available
      </span>
      <span className="cal-legend__item">
        <span className="cal-swatch cal-swatch--off" /> Off
      </span>
      <span className="cal-legend__item">
        <span className="cal-swatch" /> Not set
      </span>
      <span className="cal-legend__item">
        <span className="cal-swatch cal-swatch--pending" /> Asked to come in
      </span>
      <span className="cal-legend__item">
        <span className="cal-swatch cal-swatch--accepted" /> Coming in
      </span>
    </div>
  )
}

/**
 * Under the grid: while idle, the way into picking several days; while
 * picking, how many and the button that sets them. One place for both, so the
 * button that starts it becomes the bar that finishes it.
 */
export function SelectionBar({
  selecting,
  count,
  onStart,
  onCancel,
  onClear,
  onSet,
}: {
  selecting: boolean
  count: number
  onStart: () => void
  onCancel: () => void
  onClear: () => void
  onSet: () => void
}): JSX.Element {
  if (!selecting) {
    return (
      <div className="avail-selection avail-selection--idle">
        <span className="muted">
          Setting a week or two? Pick the days, then set them all at once.
          <span className="avail-hint--mouse"> You can also drag across days, or Shift-click.</span>
        </span>
        <button onClick={onStart}>Select days</button>
      </div>
    )
  }
  return (
    <div className="avail-selection" role="status">
      <span className="avail-selection__count">
        {count === 0 ? 'Tap the days you want to set' : `${count} ${count === 1 ? 'day' : 'days'} selected`}
      </span>
      <span className="avail-selection__actions">
        <button onClick={count === 0 ? onCancel : onClear}>{count === 0 ? 'Cancel' : 'Clear'}</button>
        <button className="primary" disabled={count === 0} onClick={onSet}>
          {count > 1 ? `Set ${count} days…` : 'Set day…'}
        </button>
      </span>
    </div>
  )
}
